var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link--mallki",class:_vm.className,style:({ 'font-size': _vm.fontSize }),attrs:{"href":"#"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('span',{attrs:{"data-letters":_vm.text}}),_vm._v(" "),_c('span',{attrs:{"data-letters":_vm.text}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4d14116","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextHoverEffect/Mallki.vue
// module id = null
// module chunks = 